export const getCountNoun = (
  count: number,
  singular: string,
  plural: string,
): string => (count === 1 ? singular : plural);

export const formatCountLabel = (
  count: number,
  singular: string,
  plural: string,
): string => `${count} ${getCountNoun(count, singular, plural)}`;
